import { OfficeServerDetails } from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_GET_ALL_OFFICE_SERVERS,
  TriggerGetAllOfficeServers,

  GET_ALL_OFFICE_SERVERS_PENDING,
  GetAllOfficeServersPending,

  GET_ALL_OFFICE_SERVERS_SUCCESS,
  GetAllOfficeServersSuccess,

  GET_ALL_OFFICE_SERVERS_ERROR,
  GetAllOfficeServersError,

  UPDATE_OFFICE_SERVERS,
  UpdateOfficeServers,

  RESET_GET_ALL_OFFICE_SERVERS,
  ResetGetAllOfficeServers
} from "./types";

export const triggerGetAllOfficeServers = (): TriggerGetAllOfficeServers => {
  return {
    type: TRIGGER_GET_ALL_OFFICE_SERVERS,
  };
};

export const getAllOfficeServersPending = (): GetAllOfficeServersPending => {
  return {
    type: GET_ALL_OFFICE_SERVERS_PENDING
  };
};

export const getAllOfficeServersSuccess = (officeServers: OfficeServerDetails[]): GetAllOfficeServersSuccess => {
  return {
    type: GET_ALL_OFFICE_SERVERS_SUCCESS,
    payload: { officeServers }

  };
};

export const getAllOfficeServersError = (): GetAllOfficeServersError => {
  return {
    type: GET_ALL_OFFICE_SERVERS_ERROR,
  };
};

export const updateOfficeServers = (officeServers: OfficeServerDetails[]): UpdateOfficeServers => {
  return {
    type: UPDATE_OFFICE_SERVERS,
    payload: { officeServers }

  };
};

export const resetGetAllOfficeServers = (): ResetGetAllOfficeServers => {
  return {
    type: RESET_GET_ALL_OFFICE_SERVERS,
  };
};